import { AssignmentStatusNames } from "./get-assignment-status-name";

const assignmentStatus = [
  "661829ad7b4df03548c40400",
  "66182a7e7b4df03548c40407",
  "68e4a759759d16f7e83d4815",
  "68e4a794759d16f7e83d4816",
  "68e4a7c8759d16f7e83d4817",
];

export const OperatorAssignmentStatus = Object.fromEntries(
  Object.entries(AssignmentStatusNames).filter(([key]) =>
    assignmentStatus.includes(key)
  )
);
export default function getOperatorAssignmentStatus(status) {
  return OperatorAssignmentStatus[status] || "Rechazada por el paciente";
}
